import React, { useEffect, useState } from "react";
import ChatBox from "../../components/chat-box/ChatBox";
import ChatNav from "../../components/chat-nav/ChatNav";
import Likes from "../../components/likes/Likes";
import Matches from "../../components/matches/Matches";
import Navbar from "../../components/navbar/Navbar";
import Others from "../../components/others/Others";
// import Requests from '../../components/requests/Requests'
import { MobileSidebar } from "../../components/sidebar/sidebar";
import styles from "./chat.module.css";

export default function Chat() {
  const pathname = window.location.pathname.split("/");
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth <= 768);
    window.onresize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
  }, []);

  const useMatchContainer = pathname.includes("matches");
  const matchContainerClass = useMatchContainer
    ? styles.matchContainer
    : styles.matchContainerWithHeight;

  return (
    <section className={[styles.chatLayout, "chat"].join(" ")}>
      <MobileSidebar />

      <div
        className={[matchContainerClass, styles.matchBox].join(" ")}
        style={{
          position: "relative", justifyContent: "space-between"
        }}
      >
        <div style={{ height: "100%" }}>
          <ChatNav />
          {pathname.includes("matches") && <Matches />}
          {pathname.includes("likes") && <Likes />}
          {pathname.includes("others") && <Others />}
        </div>
      </div>
      {isMobile && (
        <div className={`${styles.mainContains} ${styles.navWrapper}`}>
          <Navbar />
        </div>
      )}

      <ChatBox className={styles.chatBox} />
    </section>

  );
}
